<div
  [ngClass]="
    layout === 'page'
      ? 'crm-scroll min-h-0 flex-1 overflow-auto'
      : layout === 'embedded'
        ? 'crm-scroll overflow-x-auto rounded-lg border !border-slate-200'
        : 'crm-scroll overflow-x-auto'
  "
>
  <table class="w-full border-collapse text-left text-sm tabular-nums" [ngClass]="minWidth">
    <thead
      class="bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500"
      [class.sticky]="layout === 'page'"
      [class.top-0]="layout === 'page'"
      [class.z-10]="layout === 'page'"
    >
      <tr>
        @for (column of columns; track column.key; let first = $first) {
          <th [ngClass]="columnClasses(column, first)">
            @if (headerTemplates[column.key]; as template) {
              <ng-container [ngTemplateOutlet]="template" />
            } @else if (column.header) {
              {{ column.header | translate }}
            } @else {
              {{ column.label }}
            }
          </th>
        }
        @if (actions.length) {
          <th [ngClass]="[actionsClass, actionsPadding()]"></th>
        }
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        @for (item of skeleton; track item) {
          <tr class="!border-t !border-slate-100">
            <td class="px-4 py-3" [attr.colspan]="colspan">
              <div class="animate-pulse rounded bg-slate-100" [ngClass]="size === 'md' ? 'h-8' : 'h-6'"></div>
            </td>
          </tr>
        }
      } @else {
        @for (row of rows; track trackBy(row); let index = $index) {
          <tr
            class="!border-t !border-slate-100 align-middle transition"
            [ngClass]="rowClasses(row)"
            (click)="onRowClick(row, $event)"
          >
            @for (column of columns; track column.key; let first = $first) {
              <td [ngClass]="columnClasses(column, first, row)">
                @if (cellTemplates[column.key]; as template) {
                  <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: row, index: index }"
                  />
                } @else {
                  {{ cellValue(column, row) }}
                }
              </td>
            }
            @if (actions.length) {
              <td [ngClass]="actionsPadding()">
                <div class="flex justify-end gap-0.5">
                  @for (action of actions; track $index) {
                    @if (action.visible?.(row) ?? true) {
                      <button
                        type="button"
                        class="inline-flex h-8 w-8 items-center justify-center rounded transition disabled:opacity-40"
                        [ngClass]="actionClasses(action, row)"
                        [matTooltip]="resolve(action.tooltip, row) | translate"
                        [disabled]="action.disabled?.(row) ?? false"
                        (click)="runAction(action, row, $event)"
                      >
                        <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">{{
                          resolve(action.icon, row)
                        }}</app-icon>
                      </button>
                    }
                  }
                </div>
              </td>
            }
          </tr>
          @if (rowAfter) {
            <ng-container
              [ngTemplateOutlet]="rowAfter.template"
              [ngTemplateOutletContext]="{ $implicit: row, index: index, colspan: colspan }"
            />
          }
        } @empty {
          <tr>
            <td [attr.colspan]="colspan">
              @if (empty) {
                <ng-container [ngTemplateOutlet]="empty.template" />
              } @else {
                <div
                  class="flex flex-col items-center justify-center gap-2 px-4 text-center"
                  [ngClass]="layout === 'page' ? 'min-h-64 py-10' : 'py-8'"
                >
                  @if (emptyIcon) {
                    <app-icon class="!text-[32px] text-slate-300">{{ emptyIcon }}</app-icon>
                  }
                  @if (emptyText) {
                    <p class="m-0 text-sm font-medium text-slate-500">{{ emptyText | translate }}</p>
                  }
                </div>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
